import React from 'react';
import {Button} from 'reactstrap';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../util/translationUtility';

const MoreButton = ({onClick}) => 
<Button
    block
    onClick={onClick}
>
{translateResourceString("/SearchApp/Pagination/Article/LoadMore")}
</Button>;

MoreButton.propType = {
    onClick: PropTypes.func.isRequired
};

export default MoreButton;